import React, {Component} from 'react';
import {connect} from 'react-redux';

import ViewButtons from './view-buttons';
import {PER_PAGE} from '../../actions/index';

class LimitCount extends Component {
	constructor(props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(event) {
		this.props.dispatch({
			type: PER_PAGE,
			payload: event.target.getAttribute('data-count')
		});
	}


	renderLimitCountOptions() {
		const options = [12, 36, 64];
		return options.map(option => {
			return (<li key={option}>
				<button type="button"
						name={"display-" + option}
						data-count={option}
						onClick={this.handleChange}>Display {option}</button>
			</li>);
		});
	}

	render() {
		return (<div className="sorting-bar" id="archive-sorting-bar">
			<div className="dropdown pull-left">
				<button className="btn btn-default dropdown-toggle" type="button" id="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
					Displaying {this.props.posts.length} of {this.props.pagination.totalResults}<span className="caret"></span>
				</button>
				<ul className="dropdown-menu" aria-labelledby="">
					{this.renderLimitCountOptions()}
				</ul>
			</div>
			<ViewButtons />
		</div>);
	}
}

function mapStateToProps({pagination, posts}) {
	return {pagination, posts};
}

export default connect(mapStateToProps)(LimitCount);